import { useLanguage } from '../../context/LanguageContext';

export default function GalleryFilter({ categories, activeCategory, onCategoryChange }) {
  const { language } = useLanguage();

  return (
    <div className="flex flex-wrap justify-center gap-2 mb-8">
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onCategoryChange(cat.id)}
          className={`px-5 py-2.5 rounded-full font-medium text-sm transition-colors ${
            activeCategory === cat.id
              ? 'bg-primary-600 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
        >
          {cat.label[language]}
        </button>
      ))}
    </div>
  );
}
